
import React, { useState, useEffect } from 'react';
import { database } from '../firebase';
import { ref, onValue, query, orderByChild } from 'firebase/database';
import TimelinePost from './TimelinePost';

const Timeline = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const postsRef = query(ref(database, 'timeline'), orderByChild('createdAt'));
    const unsubscribe = onValue(postsRef, (snapshot) => {
      const postsData = [];
      snapshot.forEach((childSnapshot) => {
        postsData.push({ id: childSnapshot.key, ...childSnapshot.val() });
      });
      setPosts(postsData.reverse());
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center mb-10">
        <h1 className="text-4xl md:text-5xl font-bold mb-3 bg-gradient-to-r from-blue-700 via-blue-500 to-amber-500 bg-clip-text text-transparent">
          Novedades
        </h1>
        <p className="text-gray-600 text-lg">Las últimas actualizaciones de nuestra comunidad</p>
      </div>
      <div className="max-w-7xl mx-auto">
        {posts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post) => <TimelinePost key={post.id} post={post} />)}
          </div>
        ) : (
          <div className="text-center py-16 bg-white rounded-2xl shadow-lg">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 mx-auto text-gray-300 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9.5a2.5 2.5 0 00-2.5-2.5H15" />
            </svg>
            <p className="text-gray-500 text-lg">No hay novedades todavía.</p>
            <p className="text-gray-400 text-sm mt-2">Pronto compartiremos las últimas noticias</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Timeline;
